// extracted by mini-css-extract-plugin
export default {"pageContainer":"Profile_pageContainer__CPUCx","spinnerContainer":"Profile_spinnerContainer__vbuaE","spinner":"Profile_spinner__X+kiK","spin":"Profile_spin__UywJx"};